import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutWindow"><Path d="M3 11.25V3H11.25V11.25H3Z" fill="currentColor"/><Path d="M3 12.75V21L11.25 21V12.75H3Z" fill="currentColor"/><Path d="M12.75 21L21 21V12.75H12.75V21Z" fill="currentColor"/><Path d="M21 11.25V3H12.75V11.25H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutWindow;
